import React from "react";
import { Box, CircularProgress, Typography, styled } from "@mui/material";

const FallbackContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
  width: "100%",
  backgroundColor: theme.palette.background.default
}));

const FallbackUI: React.FC = () => {
  return (
    <FallbackContainer>
      <CircularProgress size={60} thickness={5} color='primary' sx={{ mb: 2 }} />

      <Typography variant='body1' color='text.secondary'>
        Loading content... Please wait.
      </Typography>
    </FallbackContainer>
  );
};

export default FallbackUI;
